import { css } from "@emotion/react";

export const popupListContainer = () => css`
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 999;
  }

  .popup-container {
    position: fixed;
    top: 7%;
    left: 18rem;
    //Product fruits background color
    background: #f3f5f7;
    padding: 1rem;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    z-index: 2000;
  }

  .popup-close {
    background: none;
    border: none;
    font-size: 1.2rem;
    position: absolute;
    padding: 0;
    top: 0.3rem;
    right: 0.5rem;
    cursor: pointer;
  }

  .popup-content {
    margin-top: 1.5rem;
    max-height: 30rem;
    overflow-y: auto;
  }

  &.hidden {
    display: none;
  }
`;
